import * as moment from "moment";

export function isSameDayForTimestamps(epoch1: number, epoch2: number) {
  const date1 = new Date(epoch1);
  const date2 = new Date(epoch2);
  return (
    date1.getMonth() === date2.getMonth()
    && date1.getFullYear() === date2.getFullYear()
    && date1.getDate() === date2.getDate()
  );
}

export function generateNDaysDateObjects(lastDate: Date, noOfDays: number): Date[] {
  const dates: Date[] = [lastDate];
  for (let i = 0; i < noOfDays; i++) {
    dates.unshift(moment(lastDate).subtract(i + 1, "days").toDate());
  }
  return dates;
}